/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOApplyLeaveModal from './DTOApplyLeaveModal';
import ApplyLeaveModalPresenter from './ApplyLeaveModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { leavesService } from '../../../../api/services/leavesService';
import {
  setAllLeaveApplied,
  setRefetch,
  setRefreshLeaveApplied,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveAppliedSlice';
import {
  setAllLeaveHistory,
  setRefreshLeaveHistory,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';
import toast from 'react-hot-toast';
import browserTimeZone from '../../../../api/services/localtime';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
  i18n?: any;
}

const ApplyLeaveModalController = ({
  isModalOpen,
  closeModal,
  trans,
  i18n,
}: ModalInterface) => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  const [leaveTypes, setLeaveTypes] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [leaveEligibilities, setLeaveEligibilities] = useState([]);
  const [leaveEnhanceEligibilities, setLeaveEnhanceEligibilities] = useState(
    [],
  );

  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  const getData = (data: any) => {
    applyLeave(data);
  };

  const getLeaveTypeData = (data: any) => {
    setLeaveTypes(data);
  };

  const getLeaveEligibility = (data: any) => {
    setLeaveEligibilities(data);
  };
  const getLeaveEnhance = (data: any) => {
    setLeaveEnhanceEligibilities(data);
  };

  async function applyLeave(data: any) {
    setIsLoading(true);
    const empID: any = selector.authSlice.emp_id;
    const companyID: any = selector.authSlice.company_id;

    if (!data?.startDate || !data?.endDate) {
      toast.error(trans('Please fill out required inputs'));

      return;
    }

    dispatch(setRefreshLeaveApplied(true));
    const formData = new FormData();
    if (empID && companyID && data.leaveTypeId && data.dayFreq) {
      formData.append('emp_id', empID);
      formData.append('company_id', companyID);
      formData.append('leave_type_id', data.leaveTypeId);
      formData.append('start_date', data.startDate);
      formData.append('end_date', data.endDate);
      formData.append('firstSecondHalf', data.firstSecondHalf);
      formData.append('day_freq', data.dayFreq);
      formData.append('timezone', browserTimeZone);
      if (data?.reason) {
        formData.append('leave_reason', data.reason);
      }
      if (data.newattachement) {
        formData.append('attachment', data.file);
      }
      formData.append('encashtype', data.encashtype);
      formData.append('hr_view', hr_view ? '1' : '0');

      await leavesService
        .applyLeave(formData)
        .then((response) => {
          if (response.response == 'success') {
            refreshFunction();
            toast.success(trans('Leave Applied Successfully'));
            closeModal();
            dispatch(setRefetch(true));
            setIsLoading(false);
          }
        })
        .catch((err) => {
          dispatch(setRefetch(false));
          dispatch(setRefreshLeaveApplied(false));
          const _errors =
            err?.response?.data?.errors &&
            Object.keys(err?.response?.data?.errors);
          toast.error(
            err?.response?.data?.errors
              ? `${_errors.toString().toUpperCase()} Required!`
              : err?.response?.data?.data
                ? err?.response?.data?.data
                : err?.response?.data?.message,
          );
          setIsLoading(false);
        });
    } else {
      dispatch(setRefreshLeaveApplied(false));
      toast.error(trans('Please fill the missing fields!'));
    }
  }

  const refreshFunction = async () => {
    const response = await leavesService.getEmployeeAppliedLeaves(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response) {
      dispatch(setRefreshLeaveApplied(false));
      dispatch(setAllLeaveApplied(response.data));
    } else {
      dispatch(setRefreshLeaveApplied(false));
    }
    dispatch(setRefreshLeaveHistory(true));
    const response_history = await leavesService.getEmployeeLeaveHistory(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response) {
      dispatch(setAllLeaveHistory(response_history.data));
      dispatch(setRefreshLeaveHistory(false));
    } else {
      dispatch(setRefreshLeaveHistory(false));
    }
    setIsLoading(false);
  };
  return (
    <>
      <DTOApplyLeaveModal
        setAllLeaveTypesData={getLeaveTypeData}
        setLeavesEligibility={getLeaveEligibility}
        setAllLeaveEnhanceTypesData={getLeaveEnhance}
      />

      <ApplyLeaveModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allLeaveTypes={leaveTypes}
        leaveEligibility={leaveEligibilities}
        leaveEnhanceEligibilities={leaveEnhanceEligibilities}
        trans={trans}
        i18n={i18n}
        disable={isLoading}
      />
    </>
  );
};

export default ApplyLeaveModalController;
